import { useMemo } from 'react'

import { useApiClient } from 'clients/yogi-api'
import { HomeService } from 'features/projects/service/service'

export { HomeService } from 'features/projects/service/service'

export function useHomeService(): HomeService {
  const client = useApiClient()
  return useMemo(() => new HomeService(client), [client])
}
